import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  getAnswersAsDataTable,
  getAnswersByQuestionId,
  createNewAnswer,
  editAnswer,
  setCorrectAnswer,
  deleteAnswer,
} from './thunks';
import { AnswersState } from './types';

export const name = 'answers';

const initialState: AnswersState = {
  dataTable: {
    data: null,
    status: 'idle',
  },
  lookups: {},
  create: {
    status: 'idle',
  },
  update: {
    status: 'idle',
  },
  setCorrect: {
    status: 'idle',
  },
  delete: {
    status: 'idle',
  },
};

export const getAnswersAsDataTableAsync = createAsyncThunk(
  name + '/getAnswersAsDataTable',
  getAnswersAsDataTable
);

export const getAnswersByQuestionIdAsync = createAsyncThunk(
  name + '/getAnswersByQuestionId',
  getAnswersByQuestionId
);

export const createNewAnswerAsync = createAsyncThunk(
  name + '/createNewAnswer',
  createNewAnswer
);

export const editAnswerAsync = createAsyncThunk(
  name + '/editAnswer',
  editAnswer
);

export const setCorrectAnswerAsync = createAsyncThunk(
  name + '/setCorrectAnswer',
  setCorrectAnswer
);

export const deleteAnswerAsync = createAsyncThunk(
  name + '/deleteAnswer',
  deleteAnswer
);

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: () => {
      return initialState;
    },
    clearDataTableData: (state) => {
      state.dataTable.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAnswersAsDataTableAsync.pending, (state) => {
        state.dataTable.status = 'loading';
      })
      .addCase(getAnswersAsDataTableAsync.fulfilled, (state, action) => {
        state.dataTable = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(getAnswersAsDataTableAsync.rejected, (state) => {
        state.dataTable.status = 'failed';
      })
      .addCase(getAnswersByQuestionIdAsync.pending, (state, action) => {
        state.lookups = {
          ...state.lookups,
          [action.meta.arg]: {
            status: 'loading',
          },
        };
      })
      .addCase(getAnswersByQuestionIdAsync.fulfilled, (state, action) => {
        state.lookups = {
          ...state.lookups,
          [action.meta.arg]: {
            status: 'idle',
            data: action.payload,
          },
        };
      })
      .addCase(getAnswersByQuestionIdAsync.rejected, (state, action) => {
        state.lookups = {
          ...state.lookups,
          [action.meta.arg]: {
            status: 'failed',
          },
        };
      })
      .addCase(createNewAnswerAsync.pending, (state) => {
        state.create.status = 'loading';
      })
      .addCase(createNewAnswerAsync.fulfilled, (state) => {
        state.create.status = 'idle';
      })
      .addCase(createNewAnswerAsync.rejected, (state) => {
        state.create.status = 'failed';
      })
      .addCase(editAnswerAsync.pending, (state) => {
        state.update.status = 'loading';
      })
      .addCase(editAnswerAsync.fulfilled, (state) => {
        state.update.status = 'idle';
      })
      .addCase(editAnswerAsync.rejected, (state) => {
        state.update.status = 'failed';
      })
      .addCase(setCorrectAnswerAsync.pending, (state) => {
        state.update.status = 'loading';
      })
      .addCase(setCorrectAnswerAsync.fulfilled, (state) => {
        state.update.status = 'idle';
      })
      .addCase(setCorrectAnswerAsync.rejected, (state) => {
        state.update.status = 'failed';
      })
      .addCase(deleteAnswerAsync.pending, (state) => {
        state.delete.status = 'loading';
      })
      .addCase(deleteAnswerAsync.fulfilled, (state) => {
        state.delete.status = 'idle';
      })
      .addCase(deleteAnswerAsync.rejected, (state) => {
        state.delete.status = 'failed';
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
